import { render } from "./SourceWithTermsView.vue?vue&type=template&id=28ec87da&scoped=true&ts=true"
import script from "./SourceWithTermsView.vue?vue&type=script&lang=ts"
export * from "./SourceWithTermsView.vue?vue&type=script&lang=ts"

import "./SourceWithTermsView.vue?vue&type=style&index=0&id=28ec87da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ec87da"]])

export default __exports__